import { gql } from 'graphql-request'
import { fragmentMediaQuery } from '../fragments/media'

export const GlobalNewsletterPageQuery = gql`
  query GlobalNewsletterPage(
    $locale: LocaleInputType!
    $isPreview: Boolean! = false
  ) {
    NewsletterPage(locale: $locale, draft: $isPreview) {
      title
      tagline
      image ${fragmentMediaQuery}
    }
  }
`
